<template>
  <h4 class="font-bold text-gray-800 mt-8 mb-4">Recent Pipeline Reviews</h4>
  <HFetchQuery :query="reviewsQuery">
    <template #default="{ data }">
      <ZeroState v-if="filteredReviews(data).length === 0"> No pipeline reviews yet. </ZeroState>
      <div v-else>
        <Accordion type="single" collapsible class="w-full">
          <AccordionItem
            v-for="pipelineReview in filteredReviews(data)"
            :key="pipelineReview.id"
            :value="String(pipelineReview.id)"
            class="border-none"
          >
            <Card class="p-0 mb-4">
              <CardContent>
                <AccordionTrigger class="w-full">
                  <div class="flex justify-between items-center text-base font-bold">
                    {{ formatStandardDate(pipelineReview.created_at) }}
                  </div>
                </AccordionTrigger>
                <AccordionContent class="border-t border-gray-200">
                  <ReviewDisplay :pipeline-review="pipelineReview" :teammate="teammate" />
                </AccordionContent>
              </CardContent>
            </Card>
          </AccordionItem>
        </Accordion>
      </div>
    </template>
  </HFetchQuery>
</template>

<script setup lang="ts">
import ZeroState from '@/components/ZeroState.vue';
import ReviewDisplay from '@/components/shared/pipeline_reviews/ReviewDisplay.vue';
import { formatStandardDate } from '@/utilities/format';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Card, CardContent } from '@/components/ui/card';
import { Api } from '@/api';
import type { PipelineReviewListResponse } from '@/api/pipeline_reviews';
import HFetchQuery from '@/lib/hfetch/HFetchQuery.vue';
import { useHFetchQuery } from '@/lib/hfetch/useHFetchQuery';

const props = defineProps<{
  teammate: { id: number };
  contactEvent: { id: number };
}>();

const reviewsQuery = useHFetchQuery(() => Api.PipelineReviews.listPipelineReviews(props.teammate.id));

const filteredReviews = (reviews: PipelineReviewListResponse[]) =>
  reviews.filter(pr => pr.contact_event_id !== props.contactEvent.id);
</script>
